module.exports = __webpack_public_path__ + "img/layout_fish_left.5cd31241.svg";